import { LockCheckOutlineIcon } from './LockCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4A17CD48-4EFA-41A5-9A40-4BF9C01F2B18
 * name lock-check-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-check-outline.svg
 * tags
 * - Lock 
 */
export const PasswordVerifiedOutlineIcon = LockCheckOutlineIcon;
export default PasswordVerifiedOutlineIcon